/**
 *
 */
export const exclamationTriangle = {
    paths: [
        {
            d: 'M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575ZM8 5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 5Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=exclamation-triangle.js.map